import React from 'react';
import './HorizontalScrollList.scss';
import * as $ from "jquery";
class HorizontalScrollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isScrollRightEnd: true,
            isScrollLeftEnd: true
        };

        this.listScrollInterval = null;
        this.scrollInterval = null;
    }

    componentDidMount(){
        this.addListScrollListener();
        this.initListScrollState();
    }

    initListScrollState = () => {
        if (this.listScrollInterval) {
            clearInterval(this.listScrollInterval);
            this.listScrollInterval = null;
        }
        let scrollElement = document.getElementById(this.props.id);
        if (scrollElement) {
            this.setState({ isScrollRightEnd: true });
            let intervalLimit = 25; // 5 second clear interval
            if (scrollElement.scrollLeft !== 0) {
                $(`#${this.props.id}`).animate({ scrollLeft: 0 }, { duration: 500, delay: 0 });
            }
            this.listScrollInterval = setInterval(() => {
                intervalLimit--;
                if ((scrollElement.clientWidth != scrollElement.scrollWidth) && (scrollElement.clientWidth > 0 || intervalLimit < 0)) {
                    if (scrollElement.scrollWidth > scrollElement.clientWidth && this.state.isScrollRightEnd) {
                        this.setState({ isScrollRightEnd: false });
                    }
                    clearInterval(this.listScrollInterval);
                    this.listScrollInterval = null;
                }
            }, 100);
        }
    }

    clearAllInterval = () => {
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        }
    }

    listScrollListener = (e) => {
        let scrollElement = e.target;
        if (scrollElement) {
            if (scrollElement.scrollLeft + scrollElement.clientWidth > scrollElement.scrollWidth - 100) {
                if (!this.state.isScrollRightEnd) {
                    this.setState({ isScrollRightEnd: true });
                }
            } else {
                if (this.state.isScrollRightEnd) {
                    this.setState({ isScrollRightEnd: false });
                }
            }
            if(scrollElement.scrollLeft > 100){
                this.setState({ isScrollLeftEnd: false });
            }else{
                this.setState({ isScrollLeftEnd: true });
            }
        }
    }

    addListScrollListener = () => {
        let scrollElement = document.getElementById(this.props.id);
        if (scrollElement) {
            scrollElement.addEventListener('scroll', this.listScrollListener)
        }
    }

    clearAllListener = () => {
        let scrollElement = document.getElementById('event-scroll-list');
        if (scrollElement) {
            scrollElement.removeEventListener('scroll', this.listScrollListener)
        }
    }

    scroll=(isScrollLeft)=>{
        let scrollElement = document.getElementById(this.props.id);

        if(isScrollLeft){
            $(`#${this.props.id}`).animate({ scrollLeft: scrollElement.scrollLeft + 300 }, { duration: 500, delay: 0 });
        }else{
            $(`#${this.props.id}`).animate({ scrollLeft: scrollElement.scrollLeft - 300 }, { duration: 500, delay: 0 });

        }
    }

    render() {
        let containerMaskClassName = '';
        if(!this.state.isScrollLeftEnd && !this.state.isScrollRightEnd){
            containerMaskClassName = 'list-container-with-mask';
        }else if(this.state.isScrollLeftEnd && !this.state.isScrollRightEnd){
            containerMaskClassName = 'list-container-with-right-mask';
        }else if(!this.state.isScrollLeftEnd && this.state.isScrollRightEnd){
            containerMaskClassName = 'list-container-with-left-mask';
        }

        return (
            <div className={`HorizontalScrollList`} >
                <img alt="" className={`arrow-left-icon ${this.state.isScrollLeftEnd ? 'hide' : ''}`} src={require("../../assets/images/bookingpage/arrowLeft.png")} onClick={()=>{this.scroll(false)}}/>
                <div className={`list-container ${containerMaskClassName}`} id={this.props.id}>
                    {this.props.children}
                </div>
                <img alt="" className={`arrow-right-icon ${this.state.isScrollRightEnd ? 'hide' : ''}`} src={require("../../assets/images/bookingpage/arrowRight.png")} onClick={()=>{this.scroll(true)}}/>

            </div>
        )
    }
}

export default HorizontalScrollList;
